import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import SwiperStyle1 from './SwiperStyle1';
import SwiperStyle2 from './SwiperStyle2';
import SwiperStyle3 from './SwiperStyle3';
import Select from './Select';
import { gptcountset } from '../redux/userInfo';
import { close, listupdater, loadingflas, open } from '../redux/popupSlice';
import * as APIS from "../utils/service";
import ProductDetailwrite from './ProductDetailwrite';
import PopCustomLeftDetail from './PopCustomLeftDetail';

import consts from '../libs/consts';
import { getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import Contractwrite from './Contractwrite';
import ScheduleInputs from './ScheduleInputs';
import { useGoogleLogin } from '@react-oauth/google';
import { configopen } from '../redux/configSlice';

import { Map, MapMarker } from "react-kakao-maps-sdk"
import Checkbox from './Checkbox';

// 신규 모듈
import { useMediaQuery } from 'react-responsive'
import { motion, MainText } from "framer-motion"
import { useInView } from 'react-intersection-observer';
import PolicyContents from './PolicyContents';
import DetailpeeView from './DetailpeeView';

export default function MiniDetailPop(props) {

    const {
        row,
        setClose,

        list,
        setproductdetailflag = () => { },
        setproductsendflag = () => { },
        setproducttogetherflag = () => { },
        setSendDatas = () => { },
        productIdx = 0,
        settogetherinfoData = {},
        memberinfos = {},
    } = props;

    // 반응형 설정
    const is830 = useMediaQuery({ query: "(max-width : 830px)" });
    // 헤더 보이기 옵션
    const [headerRef, inView] = useInView();
    const [header_view, setheader_view] = useState(false);

    useEffect(() => {
        if (!inView) {
            setheader_view(true);
        } else {
            setheader_view(false);
        }
    }, [inView]);


    const dispatch = useDispatch();
    const navigate = useNavigate();

    let lastNumRef = useRef(null);

    useEffect(() => {
        if (gptCounts?.dates !== moment().format('YYYY-MM-DD')) {
            dispatch(
                gptcountset({
                    gptCounts: { dates: moment().format('YYYY-MM-DD'), counts: 0 }
                })
            );
        }
    }, []);


    const { configdata } = useSelector(s => s.configReducer);
    const { gptCounts } = useSelector(state => state.userInfo);


    // 신규 state
    const [show, setShow] = useState(false);
    const [quetion_text, setquetion_text] = useState('');
    const [middle_num, setmiddle_num] = useState('');
    const [last_num, setlast_num] = useState('');
    const [quetion_check, setquetion_check] = useState(false);
    const [img_view, setimg_view] = useState(false);
    const [detailpeeView, setdetailpeeView] = useState(false)

    let investprice = 0;
    if (row?.sell_type === '매매') {
        investprice = (row?.price_sell * 1) - (row?.now_price_all * 1);
    } else {
        investprice = (row?.price_all * 1) + (row?.price_keymoney * 1);
    }

    const [priceinfos, setpriceinfos] = useState([]);

    // console.log(configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1));

    const [detailinfos, setdetailinfos] = useState([]);

    // console.log(row);
    // console.log('>> ', row?.files);

    let files = [];
    row?.files?.map((x, i) => {
        files.push(`${consts.s3url}/${x?.file_path}`);
    });

    let bottomText = [
        {
            title: '개인정보를 제공받는 자',
            text: '주식회사 에이피링스'
        },
        {
            title: '개인정보를 제공받는 자의 개인정보 이용 목적',
            text: '모두의 매물 서비스를 이용, 간편문의 작성 내용 중개업소쪽 전달'
        },
        {
            title: '제공하는 개인정보 항목',
            text: '휴대폰 번호'
        },
        {
            title: '개인정보를 제공받는 자의 개인정보 보유 및 이용기간',
            text: '서비스 목적 달성시까지'
        },
        {
            title: '서비스 이용을 위한 필수적인 동의이므로, 동의하지 않을 경우 본 서비스를 이용하실 수 없습니다.',
            text: ''
        }
    ];

    // console.log(configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1)?.title);

    const sendQuestion = () => {
        if(middle_num.length < 4 || last_num.length < 4){
            dispatch(
                open({
                    component: '휴대폰번호를 입력해주세요.',
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            );
            return
        }
        if(!quetion_check){
            dispatch(
                open({
                    component: '필수 동의항목에 동의해주세요.',
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            );
            return
        }

        let sender = {
            i_idx: row?.idx,
            sell_type: row?.sell_type,
            title: '',
            category_1: row?.category_1,
            category_2: row?.category_2,
            sido: row?.sido,
            sigungu: row?.sigungu,
            dong: row?.dong,
            addr: row?.addr,
            price_sell: row?.price_sell * 1,
            now_price_all: row?.now_price_all * 1,
            now_price_month: row?.now_price_month * 1,
            price_all: row?.price_all * 1,
            price_month: row?.price_month * 1,
            price_keymoney: row?.price_keymoney * 1,
            price_maintenance: row?.price_maintenance * 1,
            area_supply: row?.area_supply,
            area_contract: row?.area_contract,
            area_private: row?.area_private,
            area_land: row?.area_land,
            area_floor: row?.area_floor,
            building_dong: row?.building_dong,
            building_floor: row?.building_floor,
            building_unit: row?.building_unit,
            building_count: row?.building_count,
            building_floor_all: row?.building_floor_all,
            building_floor_under_all: row?.building_floor_under_all,
            client_hp: "010"+middle_num+last_num,
            desc: quetion_text,
            users: row?.user
        }
        // console.log("sender",row);
        // console.log("sender",sender);
        // price_sell => 매매가
        // price_all => 보증금 or 월세보증금
        // price_month => 월세

        // return;
        APIS.postData('/v1/item/insertmini', sender).then(({ data }) => {
            // console.log('>>>>> ', data);
            // return;

            if (data) {

                setquetion_text('');
                setmiddle_num('');
                setlast_num('');

                dispatch(
                    open({
                        component: '문의가 등록되었습니다.',
                        title: '알림',
                        titleviewer: true,
                        alert: false,
                        button: "확인",
                        onPress: () => {
                            dispatch(close());
                        }
                    })
                );
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(response);
            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );
        }).finally(() => {
            setShow(false);
            dispatch(loadingflas({ loading: false }));
        });
    }

    /**
     * 카테고리2 이름변경
     * @param {number} idx 
     * @returns {string}
     */
    const changeTitle = (idx) => {
        let result = ""
        if (idx === 2) // 다세대
            result = "빌라·연립"
        if (idx === 3) // 단독/다가구
            result = "원·투룸"
        if (idx === 4)
            result = "주거용 오피스텔"
        if (idx === 8)
            result = "업무용 오피스텔"
        return result
    }

    useEffect(() => {
        // console.log("rowrowrow", row)
        // 가격정보 설정
        setpriceinfos(v => {
            let list = [
                { viewernames: '보증금', values: row?.sell_type === '매매' ? `${numFormat(row?.price_sell)}만원` : row?.price_all ? `${numFormat(row?.price_all)}만원` : '-' },
                { viewernames: '월세', values: row?.price_month ? `${numFormat(row?.price_month)}만원` : '-' },
                { viewernames: '관리비', values: `${numFormat(row?.price_maintenance)}원` }
            ]
            if ([5, 6, 7, 8, 9, 10].includes(row?.category_2)) {
                // 상업 또는 건물-상가주택, 빌딩/상업용건물에 권리금 추가
                if (row?.iskeymoney * 1 === 1) {
                    //미노출
                    list.push({ viewernames: '권리금', values: row?.iskeymoney * 1 === 1 ? `권리금 문의` : '-' })
                } else {
                    //노출
                    list.push({ viewernames: '권리금', values: (row?.iskeymoney * 1 === 0 && row?.price_keymoney) ? `${numFormat(row?.price_keymoney)}만원` : '무권리' })
                }

            }
            
            // list.push({ viewernames: '실투자금', values: investprice ? `${numFormat(investprice)}만원` : '-' })
            return list
        })

        // console.log("rowrowrowrowrow:", row);
        // 상세정보 설정
        if (Number(row?.category_1) === 3) {
            //건물
            setdetailinfos([
                {
                    viewernames: '매물종류',
                    values: configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1)?.title ?
                        configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1)?.title
                        :
                        '-'
                },
                { viewernames: '건물명', values: row?.title ? row?.title : '-' },
                { viewernames: '지상 총 층', values: row?.building_floor_all ? `${row?.building_floor_all}층` : '-' },
                { viewernames: '지하 총 층', values: row?.building_floor_under_all ? `${row?.building_floor_under_all}층` : '-' },
                // { viewernames: '층 수', values: row?.building_floor ? `${row?.building_floor}층` : '-' },
                { viewernames: '계약면적', values: `${row?.area_contract}m²(약 ${(row?.area_contract * 0.3025).toFixed(1)}평)` },
                { viewernames: '연면적', values: `${row?.area_floor}m²(약 ${(row?.area_floor * 0.3025).toFixed(1)}평)` },
                { viewernames: '토지면적', values: `${row?.area_land}m²(약 ${(row?.area_land * 0.3025).toFixed(1)}평)` },
                { viewernames: '총 주차대수', values: `${row?.item_car_all}대` },
                { viewernames: '세대당 주차대수', values: `${row?.item_car}대` },
                { viewernames: '방향기준/방향', values: `${row?.item_direction_standard}/${row?.item_direction}` },
                { viewernames: '건축물용도', values: row?.item_usage ? `${row?.item_usage}` : '-' },
                { viewernames: '건축물일자', values: `${row?.item_date_type}/${row?.item_date}` },
                { viewernames: '입주가능일', values: (moment(row?.item_move_date).isValid() ? `${moment(row?.item_move_date).format('YYYY년 MM월 DD일')}` : row?.item_move_date ? row?.item_move_date : '협의')+(row?.item_move_type ? ", "+row?.item_move_type:"") },
                { viewernames: '방 수', values: `${row?.item_room}` },
                { viewernames: '화장실 수', values: `${row?.item_bathroom}` },
            ])

        } else {
            setdetailinfos([
                {
                    viewernames: '매물종류',
                    values: configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1)?.title ?
                        configdata?.consts?.category_1_OptionConsts?.find(x => x.idx === row?.category_1)?.title
                        :
                        '-'
                },
                { viewernames: '건물명', values: row?.title ? row?.title : '-' },
                { viewernames: '해당동 총 층', values: row?.building_dong_floor_all ? `${row?.building_dong_floor_all.replace("층", "")}층` : '-' },
                { viewernames: '층 수', values: row?.building_floor ? `${row?.building_floor.replace("층", "")}층` : '-' },
                { viewernames: '계약면적', values: `${row?.area_contract}m²(약 ${(row?.area_contract * 0.3025).toFixed(1)}평)` },

                { viewernames: '전용면적', values: `${row?.area_private}m²(약 ${(row?.area_private * 0.3025).toFixed(1)}평)` },

                { viewernames: '총 주차대수', values: `${row?.item_car_all}대` },
                { viewernames: '세대당 주차대수', values: `${row?.item_car}대` },
                { viewernames: '방향기준/방향', values: `${row?.item_direction_standard}/${row?.item_direction}` },
                { viewernames: '건축물용도', values: row?.item_usage ? `${row?.item_usage}` : '-' },
                { viewernames: '건축물일자', values: `${row?.item_date_type}/${row?.item_date}` },
                { viewernames: '입주가능일', values: (moment(row?.item_move_date).isValid() ? `${moment(row?.item_move_date).format('YYYY년 MM월 DD일')}` : row?.item_move_date ? row?.item_move_date : '협의')+(row?.item_move_type ? ", "+row?.item_move_type:"") },
                { viewernames: '방 수', values: `${row?.item_room}` },
                { viewernames: '화장실 수', values: `${row?.item_bathroom}` },
            ])
        }
    }, [row]);

    return (
        <>

            {/* 
            {customerdetailPop === true && customerdetaildata && <PopCustomLeftDetail 
                row={customerdetaildata} setcustomerdetailflag={setcustomerdetailPop} 
                customerIdx={customerdetaildata?.idx}
            /> }
            {detailwrite === true && <ProductDetailwrite setdetailwrite={setdetailwrite} uidx={productIdx} setupdatestatus={setupdatestatus} row={row} /> }
            {condetailwrite === true && <Contractwrite setdetailwrite={setcondetailwrite} uidx={productIdx} setupdatestatus={setupdatestatus} productrow={row} /> } 
            */}

            {img_view ?
                <div className={'ProductDetailArea'} style={{ zIndex: 9999 }}>
                    <div className={'ProductDetailAreaBG'}>

                        {/* <div className='swiper_big_img_close'>
                            <img src="../images/icons/x_grey.svg" width='48'
                                onClick={() => {
                                    setimg_view(!img_view);
                                }}
                            />
                        </div> */}

                        <div>
                            <SwiperStyle3
                                listsImag={files}
                                // listsImag={[
                                //     "https://cdn.myportfolio.com/2fa7df64-1825-417a-aa72-53eefa725b99/3509c3f6-19c3-4756-ab9a-a869f7ee422b_rw_1200.jpg?h=bfab6f67ebc435a293840f56a5e4229b",
                                //     "https://cdn.hankyung.com/photo/202205/01.29829960.1.jpg",
                                //     "https://img.khan.co.kr/news/2024/05/17/news-p.v1.20240517.974d7746069e44e09ebe2c411050f62e_P1.jpg",
                                // ]}
                                is830={is830}
                            />
                        </div>

                        <div className='swiper_big_img_close_btn'>
                            <Button
                                styles={{ height: 40 }}
                                className={'detailpopbuttons'}
                                buttonTxt={"닫기"}
                                onPress={() => {
                                    setimg_view(!img_view);
                                }}
                            />
                        </div>
                    </div>

                </div>
                :
                <div className={is830 ? '' : 'ProductDetailArea'} style={{ zIndex: 99999 }}>
                    <div>
                        <div className={is830 ? '' : 'ProductDetailAreaBG'}
                        //onClick={() => setproductdetailflag(false)}
                        />
                        <div className="ProductDetailpopMini">
                            <div className='ProductDetailpopMiniDiv'>
                                <div className='ProductpopContentsLeftMini'>
                                    {/* {header_view &&
                                    } */}
                                    <div className='mini_popup_header'>
                                        <p>매물번호 {row?.idx}</p>
                                        <img src="../images/icons/x_black.svg" width='24'
                                            onClick={() => {
                                                setClose();
                                            }}
                                        />
                                    </div>
                                    <div style={{ height: 52 }} />
                                    <div className='popup_img_box'
                                        ref={headerRef}
                                    >
                                        {/* <div className='close_btn'>
                                            <img src="../images/icons/close_circle_fill.svg" width='32'
                                                onClick={() => {
                                                    setClose();
                                                }}
                                            />
                                        </div> */}

                                        {files?.length > 0 &&
                                            <SwiperStyle2
                                                listsImag={files}
                                                viewFunc={() => {
                                                    setimg_view(true);
                                                }}
                                                is830={is830}
                                            />
                                        }

                                        {files?.length === 0 &&
                                            <div className='not_mini_popup_img'>
                                                <p className='title'>{memberinfos?.compony?.title}</p>
                                                {/* <p className='not_img'>등록된 이미지가 없습니다.</p> */}
                                            </div>
                                        }
                                    </div>

                                    <div className='borderwidth8' style={{ padding: 24 }}>
                                        <div className="productnumberinfos">
                                            <div className='mini_popup_id_date'>
                                                <p>매물번호 {row?.idx}</p>
                                                <div className='line' />
                                                <p>등록 {moment(row?.create_dt).format('YY.MM.DD')}</p>
                                            </div>
                                        </div>
                                        
                                        {/* <div className="productinfos1 styles3">
                                            <div className='linedotTxt'>
                                                <span>
                                                    {changeTitle(configdata?.consts?.category_2_OptionConsts?.find(x => x.idx === row?.category_2).idx) || configdata?.consts?.category_2_OptionConsts?.find(x => x.idx === row?.category_2).title}
                                                </span>
                                                <span></span>
                                                <span>{row?.sell_type}</span>
                                            </div>
                                        </div> */}
                                        
                                        <div className='mini_pop_cate_type_price'>
                                            
                                            <p className='mini_pop_detail_cate'>
                                                {changeTitle(configdata?.consts?.category_2_OptionConsts?.find(x => x.idx === row?.category_2).idx) || configdata?.consts?.category_2_OptionConsts?.find(x => x.idx === row?.category_2).title}
                                            </p>

                                            <div className='mini_pop_detail_type_price'>
                                                {row?.sell_type === '매매' && 
                                                    <div className='seltype_status_box02'>매매</div>
                                                }
                                                {row?.sell_type === '전세' && 
                                                    <div className='seltype_status_box02 orange'>전세</div>
                                                }
                                                {row?.sell_type === '월세' && 
                                                    <div className='seltype_status_box02 green'>월세</div>
                                                }
                                                

                                                {row?.sell_type === '월세' ?
                                                    <div className="price">월세 {numFormat(row?.price_all)}/{numFormat(row?.price_month)}</div>
                                                    :
                                                    <>
                                                        {row?.sell_type === '전세' ?
                                                            <div className="price">{numFormat(row?.price_all)}만원</div>
                                                            :
                                                            <div className="price">{numFormat(row?.price_sell)}만원</div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>

                                        {/* <div className='mini_popup_itemdesc'>
                                            {`${row?.itemdesc || ''}`}
                                        </div> */}
                                        <div style={{ height: 20 }}></div>
                                        
                                        <div>
                                            {row?.category_1 * 1 === 3 ?
                                                <>
                                                    <div className='mini_popup_area_info'>
                                                        <p className='title'>연면적</p>
                                                        <p className='mm_info'>{row?.area_floor}m²</p>
                                                        <p className='area_info'>(약 {(row?.area_floor * 0.3025).toFixed(1)}평)</p>
                                                    </div>
                                                    <div className='mini_popup_area_info'>
                                                        <p className='title'>토지면적</p>
                                                        <p className='mm_info'>{row?.area_land}m²</p>
                                                        <p className='area_info'>(약 {(row?.area_land * 0.3025).toFixed(1)}평)</p>
                                                    </div>
                                                </> 
                                                :
                                                <>
                                                    <div className='mini_popup_area_info'>
                                                        <p className='title'>전용면적</p>
                                                        <p className='mm_info'>{row?.area_private}㎡</p>
                                                        <p className='area_info'>({((row?.area_private * 1) / 3.3057).toFixed(2)}평)</p>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        
                                        <div className='mini_popup_line' />

                                        <div>
                                            <div className='popup_manager_div' style={{ marginBottom: 4 }}>
                                                <p className='class'>담당자명</p>
                                                <p className='names'>
                                                    {row?.user?.level * 1 === 1 ?
                                                        <>{memberinfos?.rank} / {memberinfos?.name}</> 
                                                        :
                                                        <>{row?.user?.rank} / {row?.user?.name}</>
                                                    }

                                                </p>
                                            </div>
                                            <div className='popup_manager_div'>
                                                <p className='class'>담당자번호</p>
                                                <p className='names'>{hpHypen(row?.user?.level * 1 === 1 ? memberinfos?.hp : row?.user?.hp)}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='productinfoArea2' style={{ gap: 0 }}>
                                        <div className='borderwidth8 padding_24_16'>
                                            <div className="title_txt bolds">가격 정보</div>
                                            <div className='infos'>
                                                {priceinfos?.length > 0 && priceinfos?.map((x, i) => {
                                                    if (!x) {
                                                        return;
                                                    }

                                                    if (row?.sell_type === '매매' && x?.viewernames === '보증금') {
                                                        x.viewernames = '매매가';
                                                    }

                                                    if (row?.sell_type != '월세' && x?.viewernames === '월세') {
                                                        return;
                                                    }

                                                    return (
                                                        <div key={i}>
                                                            <div>{x?.viewernames}</div>
                                                            <div>{x?.values}
                                                                {(x?.viewernames === '관리비' && [1, 2, 3, 4, 8, 10, 11].includes(row?.category_2 * 1)) &&
                                                                    <p className='popup_detail_btn' onClick={() => {
                                                                        setdetailpeeView(v => !v)
                                                                    }}>{detailpeeView? '숨기기': '세부내역'}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            {detailpeeView && <div>
                                                <DetailpeeView
                                                    style={{ marginTop: 10 }}
                                                    detailpeeJson={row?.detailpeeJson}
                                                />
                                            </div>}
                                        </div>

                                        <div className='borderwidth8 padding_24_16'>
                                            <div className="title_txt bolds">상세 정보</div>
                                            <div className='infos'>
                                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                                    if (!x) {
                                                        return;
                                                    }
                                                    if (row?.category_1 === 1) {
                                                        if (x?.viewernames === '계약면적' || x?.viewernames === '토지면적') {
                                                            return;
                                                        }
                                                    }
                                                    if (row?.category_1 === 2) {
                                                        if (x?.viewernames === '공급면적' || x?.viewernames === '토지면적') {
                                                            return;
                                                        }
                                                    }
                                                    if (row?.category_1 === 3) {
                                                        if (x?.viewernames === '계약면적' || x?.viewernames === '공급면적') {
                                                            return;
                                                        }
                                                    }
                                                    return (
                                                        <div key={i}>
                                                            <div>{x?.viewernames}</div>
                                                            <div>{x?.values}</div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
{/* 
                                        <div style={{ padding: 20 }}>
                                            <div className="title_txt bolds">특이사항</div>
                                            <textarea
                                                className='textarea1'
                                                placeholder='특이사항 없음'
                                                value={row?.desc}
                                                disabled
                                            />
                                        </div> */}
                                        {row?.itemdesc &&
                                        <div className='mini_popup_item_info borderwidth8'>
                                            <div className="title">매물 소개</div>
                                            <div className='info' style={{ whiteSpace: 'pre-line'}}>
                                                {row?.itemdesc || '매물 소개에 대해 글을 써주세요.매물 소개에 대해 글을 써주세요.매물 소개에 대해 글을 써주세요.매물 소개에 대해 글을 써주세요.'}
                                            </div>
                                            {/* <textarea
                                                className='textarea1'
                                                placeholder='매물 소개 없음'
                                                value={row?.itemdesc}
                                                disabled
                                            /> */}
                                        </div>}
                                    </div>

                                    

                                    <div
                                        style={{
                                            paddingBottom: 24,
                                            marginBottom: 92
                                        }}
                                    >   
                                        <div className='mini_popup_addr_map'>
                                            <p>위치</p>
                                            <div
                                                className="addr"
                                                style={{ cursor: 'pointer', marginTop: 0 }}
                                            >
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999" />
                                                </svg> */}
                                                {/* {
                                                    row?.dongviewer * 1 === 0 ?
                                                        <p>{row?.addr}</p> 
                                                        :
                                                        <p>{row?.sido} {row?.sigungu} {row?.dong}</p>
                                                } */}
                                                {/* {idx: 1, category_1: 1, title: '아파트', group: '집합건물'}, // 아파트
                                                {idx: 2, category_1: 1, title: '다세대', group: '집합건물'}, // 빌라
                                                {idx: 3, category_1: 1, title: '단독/다가구', group: '일반건물'}, // 원룸
                                                {idx: 4, category_1: 1, title: '오피스텔', group: '집합건물'},
                                                {idx: 5, category_1: 2, title: '상가', group: '집합건물'}, // 상가
                                                {idx: 6, category_1: 2, title: '사무실', group: '집합건물'}, // 사무실
                                                {idx: 7, category_1: 2, title: '지식산업센터', group: '집합건물'}, // 사무실
                                                {idx: 8, category_1: 2, title: '오피스텔', group: '집합건물'}, // 사무실
                                                {idx: 9, category_1: 3, title: '빌딩/상업용건물', group: '일반건물'}, // 건물
                                                {idx: 10, category_1: 3, title: '상가주택', group: '일반건물'}, // 건물
                                                {idx: 11, category_1: 3, title: '주거전용건물', group: '일반건물'} // 건물 */}
                                                {(row?.category_2*1 === 5 || row?.category_2*1 === 6 || row?.category_2*1 === 7 || row?.category_2*1 === 9) ? 
                                                <p>{row?.sido} {row?.sigungu} {row?.dong}</p>
                                                :
                                                <p>{row?.addr}</p>
                                                }
                                                

                                            </div>
                                        </div>
                                        
                                        <Map // 지도를 표시할 Container
                                            id="map"
                                            center={{ lat: row?.lat, lng: row?.lng }}
                                            style={{
                                                // 지도의 크기
                                                width: "100%",
                                                height: 300,
                                            }}
                                            level={3} // 지도의 확대 레벨
                                        >
                                            <MapMarker
                                                position={{ lat: row?.lat, lng: row?.lng }}
                                                image={{
                                                    src: "./images/icons/map-marker-svgrepo-com.svg",
                                                    size: {
                                                        width: 24, height: 24
                                                    }
                                                }}
                                            >
                                            </MapMarker>
                                        </Map>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='mini_popup_footer_buttons'>
                                <button className='left_btn'
                                    onClick={() => {
                                        document.location.href = `tel:${hpHypen(row?.user?.level * 1 === 1 ? memberinfos?.hp : row?.user?.hp)}`;
                                    }}
                                >전화연결</button>

                                <button className='right_btn'
                                    onClick={() => {
                                        
                                        setShow(!show);
                                    }}
                                >문의하기</button>
                            </div>

                            {/* <div className='mini_popup_buttons'>
                                <button className='left_btn'
                                    onClick={() => {
                                        document.location.href = `tel:${hpHypen(row?.user?.level * 1 === 1 ? memberinfos?.hp : row?.user?.hp)}`;
                                    }}
                                >전화연결</button>

                                <button className='right_btn'
                                    onClick={() => {
                                        setShow(!show);
                                    }}
                                >문의하기</button>
                            </div> */}

                            {show &&
                                <div className='quetion_sub_popup'>
                                    <div className='quetion_sub_popup_content'>

                                        <div className='quetion_top'>
                                            <p className='title'>매물문의</p>
                                            <p className='sub_title'>담당자가 개별 연락드릴 예정입니다.</p>
                                            <textarea
                                                onChange={(e) => {
                                                    setquetion_text(e.target.value)
                                                }}
                                                placeholder={`매물에 대해 궁금하신 점을 남겨주세요.\n원하시는 매물 조건을 입력하시면 더 좋은 매물을 추천받을 수 있습니다.`}
                                                style={{
                                                    width: '100%',
                                                    height: 120,
                                                    padding: 12,
                                                    borderRadius: 4,
                                                    border: '1px solid #DDD',
                                                    marginTop: "20px",
                                                    resize: "none"
                                                }}
                                            >
                                                {quetion_text}
                                            </textarea>
                                            <div className='quetion_num_div'>
                                                <p className='title'>연락처</p>
                                                <div className='quetion_num_box'>
                                                    <p className='title'>010</p>
                                                    <p className='hypen'>-</p>
                                                    <div>
                                                        <input
                                                            type={'number'}
                                                            className={'quetion_input'}
                                                            value={middle_num}
                                                            onChange={(e) => {
                                                                setmiddle_num(e?.target?.value);
                                                            }}
                                                            onInput={(e) => {
                                                                if (e.target.value.length > 4) {
                                                                    e.target.value = e.target.value.slice(0, e.target.maxLength);
                                                                }
                                                                if (e.target.value.length === 4) {
                                                                    // 다음칸으로 넘어가게
                                                                    lastNumRef?.current?.focus();
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") {
                                                                    lastNumRef?.current?.focus();
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <p className='hypen'>-</p>
                                                    <div>
                                                        <input
                                                            ref={lastNumRef}
                                                            type={'number'}
                                                            className={'quetion_input'}
                                                            value={last_num}
                                                            onChange={(e) => {
                                                                setlast_num(e?.target?.value);
                                                            }}
                                                            onInput={(e) => {
                                                                if (e.target.value.length > 4) {
                                                                    e.target.value = e.target.value.slice(0, e.target.maxLength);
                                                                }
                                                                if (e.target.value.length === 4) {
                                                                    // 다음칸으로 넘어가게
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") {

                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 4
                                            }}>
                                                <Checkbox
                                                    linetype={'checkimg'}
                                                    values={quetion_check}
                                                    setvalues={(e) => {
                                                        // console.log(e);
                                                        setquetion_check(e);
                                                    }}
                                                    namevalue={[
                                                        { names: '개인정보 수집ㆍ활용에 동의합니다.', values: 1 },
                                                    ]}
                                                    fontweights={400}
                                                    fontSizes={14}
                                                    sizes={20}
                                                />

                                                <Checkbox
                                                    linetype={'checkimg'}
                                                    values={quetion_check2}
                                                    setvalues={(e) => {
                                                        // console.log(e);
                                                        setquetion_check2(e);
                                                    }}
                                                    namevalue={[
                                                        {
                                                            names: <span>
                                                                (필수) <span className="links" href="/Agree2" target='_blank' onClick={e => {
                                                                    e.stopPropagation()
                                                                    window.open("/Agree2", "_blank")
                                                                }}>개인정보 업무처리</span> 위탁에 동의합니다.
                                                            </span>,
                                                            values: 1
                                                        }
                                                    ]}
                                                    fontweights={400}
                                                    fontSizes={14}
                                                    sizes={20}
                                                />
                                            </div> */}
                                            <PolicyContents
                                                checked={quetion_check}
                                                setChecked={setquetion_check}
                                                companyName={row?.compony?.title}
                                            />

                                            <div style={{ marginTop: 12 }}>
                                                <Button
                                                    styles={{ width: 120, height: 44, marginRight: 8 }}
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'간편문의'}
                                                    onPress={() => {
                                                        // setClose();
                                                        // setquetion_text('');
                                                        sendQuestion();
                                                    }}
                                                />
                                                <Button
                                                    styles={{ width: 120, height: 44, backgroundColor: '#ccc' }}
                                                    className={'normalbutton_middle'}
                                                    buttonTxt={'취소'}
                                                    onPress={() => {
                                                        setmiddle_num('');
                                                        setlast_num('');
                                                        setquetion_check([]);
                                                        setShow(!show);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className='quetion_bottom' style={{ background: "#FFF" }} />
                                        {/* <div className='quetion_bottom'>
                                            {bottomText?.map((x, i) => {
                                                return (
                                                    <div className='quetion_bottom_text'>
                                                        <div className='text_box'>
                                                            <div className='ball' />
                                                            <p>{x?.title}</p>
                                                        </div>

                                                        {x?.text &&
                                                            <div className='text_box'>
                                                                <div className='ball' style={{ backgroundColor: '#F1F1F1' }} />
                                                                <p style={{ fontWeight: 700 }}>{x?.text}</p>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div> */}

                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}